import accountsSubCategory from './accountsSubCategory';
import attachmentsSubCategory from './attachmentsSubCategory';
import automaticRepliesSubCategory from './automaticRepliesSubCategory';
import brandsSubscriptionsSubCategory from './brandsSubscriptionsSubCategory';
import forwardingSubCategory from './forwardingSubCategory';
import handlingSubCategory from './handlingSubCategory';
import junkEmailSubCategory from './junkEmailSubCategory';
import layoutSubCategory from './layoutSubCategory';
import messageContentSubcategory from './messageContentSubcategory';
import rulesSubCategory from './rulesSubCategory';
import surfaceActionsSubCategory from './surfaceActionsSubcategory';
import sweepSubCategory from './sweepSubCategory';
var mailCategory = {
    key: 'mail',
    titleStringKey: 'optionCategory_Mail',
    icon: "Mail" /* Mail */,
    subcategories: [
        layoutSubCategory,
        messageContentSubcategory,
        attachmentsSubCategory,
        rulesSubCategory,
        sweepSubCategory,
        junkEmailSubCategory,
        surfaceActionsSubCategory,
        accountsSubCategory,
        handlingSubCategory,
        forwardingSubCategory,
        automaticRepliesSubCategory,
        brandsSubscriptionsSubCategory,
    ],
};
export default mailCategory;
//# sourceMappingURL=category.js.map